module.exports = __webpack_public_path__ + "static/img/0772.792eb45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0772.jpg
// module id = 110
// module chunks = 0